// extracted by mini-css-extract-plugin
export default {"filterBadge":"FilterBadge_filterBadge__Zr-Ka"};